var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitSimpleDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "23px",
    viewBox: "0 0 32 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 32 0 32 23 0 23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manager-V.2.0.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin_Unit_Direct-Tunnel_Time-based_Toogle-off",
    transform: "translate(-580, -664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(160.8125, 88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Direct-Tunnel-Config",
    transform: "translate(377.1875, 499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Grid",
    transform: "translate(24.8317, 39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unit-Simple-disconnected",
    transform: "translate(17.1683, 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,18.125369 C31,20.2618417 29.260238,21.9999905 27.1217825,21.9999905 L4.87821754,21.9999905 C2.73976196,21.9999905 1,20.2618417 1,18.125369 L1,4.87469991 C1,2.73813924 2.73976196,0.999990455 4.87821754,0.999990455 L27.1217825,0.999990455 C29.260238,0.999990455 31,2.73813924 31,4.87469991 L31,18.125369 Z M27.7870038,-9.54452298e-06 L4.21299622,-9.54452298e-06 C1.88990997,-9.54452298e-06 0,1.93342446 0,4.31001067 L0,18.6899798 C0,21.066566 1.88990997,22.9999905 4.21299622,22.9999905 L27.7870038,22.9999905 C30.1099967,22.9999905 32,21.066566 32,18.6899798 L32,4.31001067 C32,1.93342446 30.1099967,-9.54452298e-06 27.7870038,-9.54452298e-06 L27.7870038,-9.54452298e-06 Z",
    id: "Fill-27",
    fill: "#FFAF63",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7870318,3.15502795 L4.21293091,3.15502795 C3.59045575,3.15502795 3.08404161,3.67310465 3.08404161,4.30991522 L3.08404161,18.6899798 C3.08404161,19.3267904 3.59045575,19.8448671 4.21293091,19.8448671 L27.7870318,19.8448671 C28.4095069,19.8448671 28.9159211,19.3267904 28.9159211,18.6899798 L28.9159211,4.30991522 C28.9159211,3.67310465 28.4095069,3.15502795 27.7870318,3.15502795 L27.7870318,3.15502795 Z",
    id: "Fill-30",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2116434,13.2382533 L20.7883566,13.2382533 L20.7883566,5.4786516 L11.2116434,5.4786516 L11.2116434,13.2382533 Z",
    id: "Fill-32",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.489826,14.2609966 C25.9523441,14.2609966 25.5149694,14.7083484 25.5149694,15.2582084 C25.5149694,15.8081638 25.9523441,16.2555156 26.489826,16.2555156 C27.0273079,16.2555156 27.4646826,15.8081638 27.4646826,15.2582084 C27.4646826,14.7083484 27.0273079,14.2609966 26.489826,14.2609966",
    id: "Fill-34",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7810048,14.8216419 C26.7576806,14.804939 26.7257732,14.8105703 26.709353,14.8342407 C26.6929328,14.8580065 26.6984373,14.8908397 26.7216681,14.9076381 C26.8285861,14.9847578 26.892401,15.1106501 26.892401,15.2442734 C26.892401,15.4713376 26.7117787,15.6561196 26.489826,15.6561196 C26.2678733,15.6561196 26.087251,15.4713376 26.087251,15.2442734 C26.087251,15.1105546 26.1510659,14.9847578 26.2578906,14.9076381 C26.2811214,14.8908397 26.2866259,14.8580065 26.270299,14.8342407 C26.2538788,14.8105703 26.2218781,14.804939 26.1985539,14.8216419 C26.0644866,14.9185188 25.9844381,15.0764807 25.9844381,15.2442734 C25.9844381,15.5293683 26.2111489,15.7613002 26.489826,15.7613002 C26.7685031,15.7613002 26.9952139,15.5293683 26.9952139,15.2442734 C26.9952139,15.0764807 26.9151654,14.9185188 26.7810048,14.8216419",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5412324,15.3096438 L26.5412324,14.8077928 C26.5412324,14.778682 26.5182815,14.7552025 26.489826,14.7552025 C26.4613705,14.7552025 26.4384196,14.778682 26.4384196,14.8077928 L26.4384196,15.3096438 C26.4384196,15.3387546 26.4613705,15.3622341 26.489826,15.3622341 C26.5182815,15.3622341 26.5412324,15.3387546 26.5412324,15.3096438 Z",
    id: "Fill-36",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02067453,12.7917414 C5.02067453,12.947508 5.14419928,13.0737821 5.29645939,13.0737821 C5.4487195,13.0737821 5.57224425,12.947508 5.57224425,12.7917414 C5.57224425,12.6358794 5.4487195,12.5096053 5.29645939,12.5096053 C5.14419928,12.5096053 5.02067453,12.6358794 5.02067453,12.7917414 Z",
    id: "Fill-37",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02067453,14.28733 C5.02067453,14.4430966 5.14419928,14.5693706 5.29645939,14.5693706 C5.4487195,14.5693706 5.57224425,14.4430966 5.57224425,14.28733 C5.57224425,14.1314679 5.4487195,14.0051939 5.29645939,14.0051939 C5.14419928,14.0051939 5.02067453,14.1314679 5.02067453,14.28733 Z",
    id: "Fill-38",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#FFFFFF",
    points: "5.96814853 13.0738107 6.16845641 12.7423294 6.0910202 12.7423294 6.16845641 12.5284367 5.97570556 12.5284367 5.92028735 12.8512324 5.99884312 12.8512324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1931427,14.1655896 L6.14919998,14.1655896 L6.14919998,14.0811206 C6.14919998,14.0665174 6.1377245,14.0547777 6.12345011,14.0547777 C6.10926902,14.0547777 6.09779353,14.0665174 6.09779353,14.0811206 L6.09779353,14.1655896 L5.99096889,14.1655896 L5.99096889,14.0811206 C5.99096889,14.0665174 5.9794001,14.0547777 5.96521901,14.0547777 C5.95103793,14.0547777 5.93956244,14.0665174 5.93956244,14.0811206 L5.93956244,14.1655896 L5.89561972,14.1655896 C5.87322853,14.1655896 5.85503569,14.1842014 5.85503569,14.2071083 C5.85503569,14.2253383 5.86669777,14.2403232 5.88274479,14.245859 C5.88629006,14.3330005 5.94376079,14.4037254 6.01867799,14.4171832 L6.01867799,14.493444 C6.01867799,14.5080471 6.03015347,14.5197868 6.04442786,14.5197868 C6.05860895,14.5197868 6.07008443,14.5080471 6.07008443,14.493444 L6.07008443,14.4171832 C6.14500163,14.4037254 6.20247236,14.3330005 6.20611093,14.245859 C6.22206465,14.2403232 6.23372673,14.2253383 6.23372673,14.2071083 C6.23372673,14.1842014 6.21553389,14.1655896 6.1931427,14.1655896",
    id: "Fill-40",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitSimpleDisconnected);
export default __webpack_public_path__ + "static/media/unit-simple-disconnected.0b0d84a177f71dfd0e1b138054e823b4.svg";
export { ForwardRef as ReactComponent };